import { defineStore } from "pinia";
import { ref } from "vue";
import type {
  AssociatedIntermediateOrder,
  BulkOrderCreationRow,
  BulkOrderLookupMode,
} from "../features/bulkOrderCreation/bulkOrderCreationMock.ts";

const DEFAULT_BULK_ORDER_CUBE_CAPACITY_FT3 = "2300";

interface BulkOrderLookupContext {
  demoMode?: boolean;
  mode: BulkOrderLookupMode;
  identifier: string;
  vendor: string;
  warehouse?: string | undefined;
  warehouseLabel?: string | undefined;
  rows: BulkOrderCreationRow[];
  associatedIntermediateOrders: AssociatedIntermediateOrder[];
}

export const useBulkOrderCreationStore = defineStore(
  "bulkOrderCreation",
  () => {
    const mode = ref<BulkOrderLookupMode>("bulk-order");
    const demoMode = ref(false);
    const identifier = ref("");
    const vendor = ref("");
    const warehouse = ref<string | undefined>(undefined);
    const warehouseLabel = ref<string | undefined>(undefined);
    const rows = ref<BulkOrderCreationRow[]>([]);
    const associatedIntermediateOrders = ref<AssociatedIntermediateOrder[]>([]);
    // Retained across navigations within the session, per business req 3.4.
    const cubeCapacityFt3 = ref<string>(DEFAULT_BULK_ORDER_CUBE_CAPACITY_FT3);

    function setLookupContext(context: BulkOrderLookupContext): void {
      demoMode.value = context.demoMode === true;
      mode.value = context.mode;
      identifier.value = context.identifier;
      vendor.value = context.vendor;
      warehouse.value = context.warehouse;
      warehouseLabel.value = context.warehouseLabel;
      rows.value = context.rows;
      associatedIntermediateOrders.value = context.associatedIntermediateOrders;
    }

    return {
      mode,
      demoMode,
      identifier,
      vendor,
      warehouse,
      warehouseLabel,
      rows,
      associatedIntermediateOrders,
      cubeCapacityFt3,
      setLookupContext,
    };
  }
);
